import React from 'react';
import { InteractionsDefinition } from '@wix/viewer-service-interactions/definition';
import { useService } from '@wix/services-manager-react';
export const withInteractions = Component => props => {
    const { hasInteractions } = useService(InteractionsDefinition);
    // TODO: change when moving to tokens
    const selector = `#${props.id}`;
    if (hasInteractions(selector)) {
        return (React.createElement("wix-interact-element", { "data-wix-path": selector },
            React.createElement(Component, { ...props })));
    }
    return React.createElement(Component, { ...props });
};
//# sourceMappingURL=withInteractions.js.map